<obg-m-dialog-layout
	[dialogId]="dialogId"
	[hideFooter]="data.hideDialogFooter"
	[hideClose]="data.hideClose"
	[preserveDialogOnLogout]="data.preserveOnLogout"
	[attr.test-id]="data.testId || 'alert-' + dialogId"
>
	<div class="content-container" (click)="onElementClick($event.target)">
		<h1 class="title" *ngIf="data.title" [innerHTML]="data.title | translate"></h1>
		<p class="message" *ngIf="data.message" [innerHTML]="data.message | translate"></p>
		<ng-container *ngIf="argentineRedirectButtonVisibility$ | async">
			<button
				class="redirect-button"
				mat-flat-button
				color="accent"
				[attr.test-id]="'alert-redirect-button'"
				(click)="navigate()"
			>
				{{ data.redirectButtonText | translate }}
			</button>
		</ng-container>
	</div>
	<div class="footer" *ngIf="data.hideDialogFooter">
		<obg-compact-footer (supportClick)="track(contactSupport)"></obg-compact-footer>
	</div>
</obg-m-dialog-layout>
